import { Component, EventEmitter, Input, Output, OnChanges, SimpleChanges, ChangeDetectorRef } from '@angular/core';

@Component({
  selector: 'app-searchable-dropdown',
  templateUrl: './searchable-dropdown.component.html',
  styleUrls: ['./searchable-dropdown.component.scss']
})
export class SearchableDropdownComponent implements OnChanges {
  @Input() data: unknown[] = [];

  @Input() value: any = null;

  @Input() labelKey: string = 'label';

  @Input() valueKey: string = 'value';

  @Input() placeholder = 'Select';

  @Input() disabled = false;

  @Output() valueChange = new EventEmitter<any>();

  constructor(private cdr: ChangeDetectorRef) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['data'] && this.data && this.data.length > 0) {
      this.data = this.data.map((item: any) => ({
        ...item,
        label: item[this.labelKey],
        value: item[this.valueKey]
      }));
    }
    if (changes['value']) {
      this.cdr.markForCheck();
    }
  }

  onUpdate(event: any): void {
    this.value = event.value;
    this.valueChange.emit(this.value);
  }
}
